import React, { useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useEmployeeLeaveBalance } from "../../../hooks/useEmployeeLeaveBalance"; // // ADDED
import { LoadingSpinner } from "../../../../common/Loading"; // // MODIFIED: Corrected path
import LeaveRequestModule from "./LeaveRequestModule";
import LeaveRequestHistory from "./components/LeaveRequestHistory";
import { useLeaveRequest } from "../../../hooks/useLeaveRequest";

function LeaveRequestTab({ user, userAccess, isHideSideMenu, showGeneralMessage }) {
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const currentEmployeePersonalInformationId = user?.employeePersonalInformationId;

  // // MODIFIED: Centralized hooks to share state between children
  const {
    requests,
    loading: requestLoading,
    formData,
    handleInputChange,
    handleFileChange,
    submitRequest,
    showMessage,
    message,
    isSuccess
  } = useLeaveRequest({
    employeePersonalInformationId: currentEmployeePersonalInformationId, 
    showGeneralMessage: showGeneralMessage
  });

  const {
    employeeLeaveCredits,
    loading: balanceLoading,
    fetchBalances // Ensure this is returned from your useEmployeeLeaveBalance hook
  } = useEmployeeLeaveBalance({
    employeePersonalInformationId: currentEmployeePersonalInformationId, 
    showGeneralMessage: showGeneralMessage
  });

  // const hasFullAccess = userAccess.isFullLeaveAccess;
  const isLoading = requestLoading || balanceLoading;

  return (
    <>
      <div className="v2-module-container">
        {/* Header */}
        <div className="mainteHeader p-4 border-b flex justify-between items-center">
          <div>
            <h3 className="text-xl font-bold">Leave Request</h3>
          </div>

          <button
            onClick={() => setShowHistoryModal(true)}
            className="flex items-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-md border-none cursor-pointer transition-colors shadow-sm font-medium"
          >
            <RemoveRedEyeIcon fontSize="small" className="mr-2" />
            VIEW HISTORY
          </button>
        </div>

        {/* {hasFullAccess && (
          <div className="mb-6 p-4 bg-gray-100 rounded-lg border-dashed border-2 border-gray-300 text-center mx-4 mt-4">
            <p className="text-gray-600 font-medium">Administrator View: Select an Employee to manage their leaves.</p>
            <button className="mt-2 text-blue-600 underline">Open Employee Selector</button>
          </div>
        )} */}

        {/* // MODIFIED: Passing all state and refresh functions to the Module */}
        <LeaveRequestModule
          user={user}
          userAccess={userAccess}
          requests={requests}
          formData={formData}
          handleInputChange={handleInputChange}
          handleFileChange={handleFileChange}
          submitRequest={submitRequest}
          showMessage={showMessage}
          message={message}
          isSuccess={isSuccess}
          loading={isLoading}
          employeeLeaveCredits={employeeLeaveCredits}
          fetchBalances={fetchBalances}
        />

      </div>

      <LeaveRequestHistory
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        data={requests || []}
      />

      {/* // MODIFIED: Spinner covers the whole page during any data operation */}
      <LoadingSpinner loading={isLoading} />
    </>
  );
}

export default LeaveRequestTab;